<template>
    <div class="marquee-wrapper" ref="container" v-if="orders">
        <div class="marquee-container" @mouseenter="pauseAnimation" @mouseleave="resumeAnimation">
            <div class="marquee-track" :style="{ transform: `translateX(${offset}px)` }">
                <div class="order-item" v-for="(displayOrder, index) in orders" :key="displayOrder.id">
                    {{index+1}}、恭喜 {{displayOrder.depart_name_short}} {{displayOrder.admin.nick_name}} 同事 喜开单
                    {{displayOrder.pay_amount}} 元！
                </div>
            </div>
        </div>

        <div class="list" v-show="showList" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
            <div v-for="(displayOrder, index) in orders" :key="displayOrder.id">
                {{index+1}}、恭喜 {{displayOrder.depart_name_short}} {{displayOrder.admin.nick_name}} 同事 喜开单
                {{displayOrder.pay_amount}} 元！
            </div>
        </div>
    </div>
</template>

<script>
    import { crmorderLists } from '@/request/apis.js'
    export default {
        name: 'Marquee',
        data() {
            return {
                orders: [],
                lastFetchTime: null,
                speed: 150,
                offset: 0,
                currentIndex: 0,
                containerWidth: 0,
                itemWidth: 0,
                animationId: null,
                isPaused: false,
                showList: false,
                hideTimeout: null,
            }
        },
        computed: {
            displayOrder() {
                console.log('displayOrders', this.currentIndex, this.orders[this.currentIndex])
                return this.orders[this.currentIndex];
            }
        },
        async mounted() {
            await this.getOrder();
            this.initDimensions()
            window.addEventListener('resize', this.initDimensions)
            this.startAnimation()
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.initDimensions)
            cancelAnimationFrame(this.animationId)
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout)
            }
        },
        methods: {
            async getOrder() {
                var today = new Date();
                var created_date = today.getFullYear() + '-' + ((today.getMonth() + 1).toString().padStart(2, '0')) + '-' + (today.getDate().toString().padStart(2, '0'));
                let res = await crmorderLists({ limit: 100, state: [10, 30, 40, 50, 60, 70], created_date: [created_date, created_date], orderAll: 1, carousel: 1 });
                this.lastFetchTime = new Date().getTime();
                if (res.code === 0 && res.data.length) {
                    this.orders = res.data;
                }
            },
            checkIfNeedRefreshOrders() {
                const now = new Date().getTime();
                const tenMinutesAgo = now - 10 * 60 * 1000;

                if (!this.lastFetchTime || this.lastFetchTime < tenMinutesAgo) {
                    console.log('超过10分钟，重新请求订单数据');
                    this.getOrder();
                }
            },
            initDimensions() {
                this.containerWidth = this.$refs.container.offsetWidth
                this.itemWidth = this.containerWidth
                this.itemWidth = Array.from(this.$refs.container.querySelectorAll('.order-item')).reduce((sum, el) => sum + el.offsetWidth, 0);
                console.log('itemWidth', this.itemWidth)
                this.offset = this.containerWidth
            },
            startAnimation() {
                let lastTime = null
                const animate = (timestamp) => {
                    if (!lastTime) lastTime = timestamp
                    const deltaTime = timestamp - lastTime
                    lastTime = timestamp

                    if (!this.isPaused) {
                        this.offset -= (this.speed * deltaTime) / 1000

                        if (this.offset <= -this.itemWidth) {
                            const prevIndex = this.currentIndex;
                            this.currentIndex = (this.currentIndex + 1) % this.orders.length;
                            this.offset = this.containerWidth;
                            if (this.orders.length > 0 && prevIndex === this.orders.length - 1 && this.currentIndex === 0) {
                                this.checkIfNeedRefreshOrders();
                            }
                        }
                    }
                    this.animationId = requestAnimationFrame(animate)
                }
                this.animationId = requestAnimationFrame(animate)
            },
            handleMouseEnter() {
                if (this.hideTimeout) {
                    clearTimeout(this.hideTimeout)
                    this.hideTimeout = null
                }
                this.isPaused = true
                this.showList = true
            },
            handleMouseLeave() {
                this.hideTimeout = setTimeout(() => {
                    this.isPaused = false
                    this.showList = false
                    this.hideTimeout = null
                }, 600)
            },
            pauseAnimation() {
                this.handleMouseEnter()
            },
            resumeAnimation() {
                this.handleMouseLeave()
            },
        }
    }
</script>

<style scoped>
    .marquee-wrapper {
        width: 100%;
        position: relative;
    }

    .marquee-container {
        width: 100%;
        overflow: hidden;
        position: relative;
        height: 36px;
        cursor: pointer;
    }

    .marquee-track {
        display: flex;
        position: absolute;
        white-space: nowrap;
        z-index: 1;
    }

    .order-item {
        flex: 0 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
        height: 36px;
        line-height: 36px;
        text-align: center;
        color: red;
        font-size: 24px;
    }

    .list {
        position: absolute;
        top: 36px;
        left: 0;
        width: 100%;
        background: white;
        border: 1px solid #ccc;
        max-height: 300px;
        overflow-y: auto;
        z-index: 999;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
    }

    .list>div {
        padding: 8px 20px;
        border-bottom: 1px solid #eee;
        height: 36px;
        line-height: 36px;
        color: red;
        font-size: 24px;
    }
</style>